import React from 'react';

import { cn } from '@lyearn/style';
import { Image } from '@/components/Image';

import { GridRenderProps } from '../types';
import { getSizeClasses } from '../utils';

const GridImage: React.FC<GridRenderProps> = ({
  media: { name, url },
  size,
  totalMedias,
  className,
}) => {
  const { classes: sizeClasses, width, height } = getSizeClasses(size, totalMedias);
  const imageClasses = cn(className, sizeClasses);

  return (
    <Image
      alt={name}
      className={imageClasses}
      height={height}
      layout={width && height ? undefined : 'fill'}
      src={url!}
      width={width}
    />
  );
};

export default React.memo(GridImage);
